import { CategoryTypeString } from '@diritto/common/content/constants';
import { ContentPublicRelayDto } from '@diritto/common/relay/dtos/content-relay.dtos';
import { ProfileLitePublicRelayDto } from '@diritto/common/relay/dtos/profile-lite-relay.dtos';
import { Color } from '@diritto/common/style/color';
import { BadgeType } from 'constants/cover';
import { Link } from 'ui-components/common/Link';
import { IconCount, IconCountType } from 'ui-components/contents/IconCount';
import { IkImage } from 'ui-components/Imagekit/IkImage';
import { CoverBadge } from 'ui-components/common/CoverBadge';
import { useContentState } from 'state-hooks/contents/useContentState';

export const SectionExclusiveContentItem = ({
  content,
  profile,
  index,
  handleOnClickTracker,
}: {
  content: ContentPublicRelayDto;
  profile: ProfileLitePublicRelayDto;
  index: number;
  handleOnClickTracker: (contentId: number, index: number) => void;
}) => {
  const state = useContentState(content);

  return (
    <Link
      href={`/contents/${content.id}`}
      className={
        'relative z-0 inline-flex flex-col justify-center items-center rounded-md w-[169px] h-[125px] p-4 overflow-hidden'
      }
      onClick={() => handleOnClickTracker(content.id, index)}>
      <div className="rounded-[100px] border border-solid border-white/10 w-[21px] h-[21px] mb-[7px] overflow-hidden">
        <IkImage
          fullWidth={true}
          transform={{
            path: content.cover.path,
            isPrivate: content.cover.isPrivate,
          }}
        />
      </div>
      <div className="flex mb-1">
        <p className={'text-white text-xxs font-bold overflow-hidden max-w-[137px] line-clamp-1 break-all break-words'}>
          {content.title}
        </p>
      </div>
      <div className="flex items-center gap-1 text-white text-xxxs font-medium mb-[4px] opacity-70">
        <p className="max-w-[95px] overflow-hidden text-ellipsis whitespace-nowrap">{profile.nickname}</p>
        <>
          <div className="w-0.5 h-0.5 opacity-30 bg-white rounded-full" />
          <p>{CategoryTypeString[content.categoryType]}</p>
        </>
      </div>
      <IconCount
        count={content.counts.viewCount || 0}
        type={IconCountType.View}
        color={Color.White}
        className="items-center opacity-70"
        iconClassName="size-[14px]"
        textClassName="!text-white text-xxxs font-medium"
      />
      <div className="absolute w-full h-full rounded-md border border-solid border-black/10 z-[-1]">
        <div className="absolute w-[150%] aspect-[253/380] left-[-25%] top-1/2 -translate-y-1/2 blur-[54px] bg-black/10">
          <div className="absolute inset-0 bg-black/10" />
          <IkImage
            fullWidth
            transform={{
              path: content.cover.path,
              isPrivate: content.cover.isPrivate,
            }}
          />
        </div>
      </div>
      <div className="absolute flex top-0 right-0 gap-0.5 p-1.5 z-[100]">
        {state.isAdult && <CoverBadge type={BadgeType.Adult} />}
      </div>
    </Link>
  );
};
